<div class="w-100 mt-0 tool-container">
  <h4>Upload Report Template</h4>
  <mat-form-field class="me-3">
    <mat-label>Template</mat-label>
    <mat-select [(ngModel)]="selectedUpdateReportTemplate">
      @for (template of reportTemplates; track template) {
        <mat-option [value]="template">
          {{ template }}
        </mat-option>
      }
    </mat-select>
  </mat-form-field>
  <mat-form-field class="me-3">
    <mat-label>Template Content</mat-label>
    <textarea matInput [(ngModel)]="selectedUpdateReportNewTemplate"></textarea>
  </mat-form-field>
  <button
    mat-raised-button
    color="primary"
    class="mx-auto"
    (click)="updateReportTemplate()"
    [disabled]="
      !selectedUpdateReportTemplate || !selectedUpdateReportNewTemplate
    "
  >
    Update
  </button>
  @if (selectedUpdateReportStatus) {
    <h4 class="col-12 {{ selectedUpdateReportStatusClass }}">
      {{ selectedUpdateReportStatus }}
    </h4>
  }
  <div>
    (Choose the template from the dropdown menu and paste the content of the
    template in the text box)
  </div>
</div>
